// Filename: public/constants.js 
export const BIEventsIDs = {
    0: 8000, // type in search box
    1: 8001, // search
    2: 8002, // open refine dropdown
    3: 8003, // select refine category
    4: 8004, // click copy title
    5: 8005, // click load more
    6: 8006, // header CTA click
    7: 8007 // secondary CTA click
}